var CustomOverlay = function (data, opts) {
  var view = data;

  return view.render();
};

module.exports = CustomOverlay;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/vis/overlays/custom.js
// module id = 1691
// module chunks = 6